import React from 'react'
import { Button, Link, Typography } from '@mui/material'
import { OrderModel } from 'src/common/api'
import { Container, SummaryTable } from 'src/ui'
import { trimId } from 'src/common/helpers'
import * as S from './styles'
import { ChainAsset, ChainName, EXPLORER, OrderStatus, RequestType } from 'src/common/static'
import { LoadingIconQCAD } from '../../../assets/LoadingIconQCAD'

interface Order extends OrderModel {
  asset: ChainAsset
  chain: ChainName
}

interface RequestInitiatedProps {
  order: Order
  type: RequestType
  networkFee?: number
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
const RequestInitiated: React.FC<RequestInitiatedProps> = ({ order, type, networkFee = 0 }: RequestInitiatedProps) => {
  const isMint = type === RequestType.MINT

  // Format date to EST (UTC-5)
  const formatDateEST = (dateString: string) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'America/New_York'
    })
  }

  const formatTimeEST = (dateString: string) => {
    const date = new Date(dateString)
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'America/New_York'
    })
  }

  return (
    <Container>
      <S.Row>
        <Typography variant="h5" fontWeight={600}>
          {isMint ? 'Mint' : 'Burn'} Order Initiated
        </Typography>
      </S.Row>
      <S.Row textAlign="center">
        <LoadingIconQCAD sx={{ fontSize: '15rem', width: '50%', height: 'auto' }} />
      </S.Row>
      <S.Row>
        <S.Summary>Summary</S.Summary>
        <S.Row>
          <SummaryTable
            data={[
              {
                key: 'Status',
                value: OrderStatus[order.status]
              },
              {
                key: 'Date & Time (EST)',
                value: `${formatDateEST(order.createdAt)} ${formatTimeEST(order.createdAt)}`
              },
              {
                key: 'Transaction ID',
                value: isMint ? (
                  order.id.toString()
                ) : order.txId ? (
                  <Link component="a" href={`${EXPLORER[order.chain]}/tx/${order.txId}`} target="_blank" rel="noopener">
                    {trimId(order.txId)}
                  </Link>
                ) : (
                  order.id.toString()
                )
              }
            ]}
          />
        </S.Row>
      </S.Row>
      <S.Row>
        <Button href="/" variant="contained" fullWidth size="large">
          Return to Dashboard
        </Button>
      </S.Row>
    </Container>
  )
}

export default RequestInitiated
